module.exports = __webpack_public_path__ + "img/104.fcd15db2.png";